/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ToggleableFeature {
    Autodoc = 'Autodoc'
}

export function ToggleableFeatureFromJSON(json: any): ToggleableFeature {
    return ToggleableFeatureFromJSONTyped(json, false);
}

export function ToggleableFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToggleableFeature {
    return json as ToggleableFeature;
}

export function ToggleableFeatureToJSON(value?: ToggleableFeature | null): any {
    return value as any;
}

